import { useModal } from "hooks";
import { useCustomerSubscription } from "hooks/use-products";
import React from "react";
import {useNavigate, useParams} from "react-router-dom";
import CancelSubscription from "../component/cancelSubscription";
import { formatDate } from "helpers/data";
import { client } from "helpers/client";
import { toast } from "react-toastify";
import moment from "moment";
import { useTranslation } from "react-i18next";

const Manage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { subscription,refetch } = useCustomerSubscription(id);
  const [showCancelSubscription, openCancelSubscription, closeACancelSubscription] = useModal(false);
  const { t } = useTranslation("browse-apps");

  async function handleUpdateAutoBill(e) {
    const isAutoBill = e.target.checked;
    const { response } = await client("/customerProduct/updateCustomerSubscription", {
      data: {
        autoBill: isAutoBill,
        versionSubscriptionId: id
      }
    });
    if (response) {
      refetch().then(() => toast.success(t('common:form.updated')));
    }
  }

  return (
    <div className="manage">
      <div className="row">
        <div className="col-xl-4">
          <div className="manageBox">
            <h1 className="title">{t("myProducts.managePage.mainTitle")}</h1>
            <p className="purchased">
            {t("myProducts.managePage.purchased")}: <span>{formatDate(subscription?.startDate)}</span>
            </p>
            <p className="next">
            {t("myProducts.managePage.newtRenewal")}:<span>{formatDate(subscription?.endDate)}</span> {moment(new Date()).isAfter(subscription?.endDate) && <span className="span-danger">(expired)</span>}
            </p>
            <hr className="hr" />
            <label className="subscribe">
              <div>
                <h3> {t("myProducts.managePage.autoBill")}</h3>
                <p>{t("myProducts.managePage.autoSubcribtion")}</p>
              </div>
              <div>
                <input
                  checked={subscription?.autoBill}
                  type="checkbox"
                  name="subscribe"
                  id="subscribe"
                  onChange={handleUpdateAutoBill}
                />
                <span></span>
              </div>
            </label>
            <hr className="hr" />
            <p className="content">
            {t("myProducts.managePage.manageInfo")}
            </p>
            {(!subscription?.autoBill && subscription.isExpired) ?
              <button className="btn-green" onClick={() => navigate("/invoices/unpaid")}>
                {t("myProducts.managePage.renewSubcription")}
              </button> : null}
            {subscription?.canCancel && (
              <button className="btn-White" onClick={openCancelSubscription}>
                {t("myProducts.managePage.cancelSubscription")}
              </button>
            )}
          </div>
        </div>
      </div>
      <CancelSubscription show={showCancelSubscription} onHide={closeACancelSubscription} />
    </div>
  );
};

export default Manage;
